import { render, staticRenderFns } from "./LoadingDataTable.vue?vue&type=template&id=6f06f342&scoped=true"
import script from "./LoadingDataTable.vue?vue&type=script&lang=ts"
export * from "./LoadingDataTable.vue?vue&type=script&lang=ts"
import style0 from "./LoadingDataTable.vue?vue&type=style&index=0&id=6f06f342&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06f342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f06f342')) {
      api.createRecord('6f06f342', component.options)
    } else {
      api.reload('6f06f342', component.options)
    }
    module.hot.accept("./LoadingDataTable.vue?vue&type=template&id=6f06f342&scoped=true", function () {
      api.rerender('6f06f342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingDataTable.vue"
export default component.exports